import React from 'react';
import { GatewayTransactionCsobStatusEnum } from '../../../../graphql-operations';

interface TransactionStatusMeta {
  label: string;
  color: string;
}

const TRANSACTION_STATUS: Record<GatewayTransactionCsobStatusEnum, TransactionStatusMeta> = {
  INITIALIZED: { label: 'Platba založena (1)', color: '' },
  IN_PROGRESS: { label: 'Platba probíhá (2)', color: '' },
  CANCELLED_BY_USER: {
    label: 'Platba zrušena uživatelem (3)',
    color: 'text-danger'
  },
  ACCEPTED: { label: 'Platba potvrzena (4)', color: 'text-success' },
  REVERSED: { label: 'Platba odvolána (5)', color: 'text-warning' },
  REJECTED: { label: 'Platba zamítnuta (6)', color: 'text-danger' },
  WAITING_FOR_CLOSE: { label: 'Čeká na zúčtování (7)', color: 'text-success' },
  CLOSED: { label: 'Platba zúčtována (8)', color: 'text-success' },
  REFUNDING: { label: 'Zpracování vrácení (9)', color: 'text-warning' },
  REFUNDED: { label: 'Platba vrácena (10)', color: 'text-warning' }
};

interface TransactionStatusProps extends React.HTMLAttributes<HTMLSpanElement> {
  status: GatewayTransactionCsobStatusEnum;
}

export default function TransactionStatus({ status, ...props }: TransactionStatusProps) {
  const statusLabel = TRANSACTION_STATUS[status];

  return (
    <span {...props} className={`${statusLabel.color} ${props.className || ''}`}>
      {statusLabel.label}
    </span>
  );
}
